import React from "react";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import * as reportApi from "../../api/reportApi";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import Tooltip from "@mui/material/Tooltip";
import { toast } from "react-toastify";
import ScrollToTopBtn from "../common/ScrollToTop";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

class StatusReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reports: [],
      member: "tff",
      page: 0,
      rowsPerPage: 10,
      sortDirection: "asc",
      loading: false,   // download in progress
      fetching: false,  // table data loading
    };
  }

  async componentDidMount() {
    try {
      this.getReports();
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  getReports = async () => {

    this.setState({ fetching: true });

    const reports = await reportApi.getReports(this.state.member);

    if (reports) {
      this.setState({ reports });
    } else {
      this.setState({ reports: [] });
    }
    this.setState({ fetching: false, page: 0 });
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 });
  };

  handleRadioButton = async (e) => {
    await this.setState({ member: e.target.value });
    this.getReports();
  };

  subtotal = (column) => {
    const { reports } = this.state;

    const SumValue = reports.reduce((total, report) => {
      const value = report[column.id] || 0;
      return total + value;
    }, 0);

    return SumValue.toLocaleString("de-DE");
  };

  handledownload = async () => {
    const { member, loading } = this.state;

    if (loading) return;

    try {
      this.setState({ loading: true });

      const excelfile = await reportApi.getExcelFileStatusReport(member, true);
      if (excelfile === false) {
        toast.error("Ingen data");
      }
    } catch (error) {
      console.error("Error downloading Status Report data:", error);
      toast.error("Noe gikk galt ved generering av rapporten");
    } finally {
      this.setState({ loading: false });
    }
  };

  compareBy = (key, direction) => {
    return (a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    };
  };

  sortBy = (key) => {
    const { sortDirection, reports } = this.state;
    const newDirection = sortDirection === "asc" ? "desc" : "asc";
    const sortedArray = [...reports].sort(this.compareBy(key, newDirection));

    this.setState({
      reports: sortedArray,
      sortDirection: newDirection,
    });
  };

  render() {
    const columns = [
      { id: "incidentYear", label: "Skadeår" },
      {
        id: "paid",
        label: "Akkumulert Betalt",
        align: "right",
        minWidth: 150,
        format: (value) => value.toLocaleString("de-DE"),
        title:
          "Akkumulert Betalt: akkumulert nettoutbetalt erstatning (utbetalt - (regress + finansinntekter)) f.o.m. 01.01.1990 t.o.m. 31.05.2016",
      },
      {
        id: "costs",
        label: "Akkumulerte Kostnader",
        align: "right",
        minWidth: 150,
        format: (value) => value.toLocaleString("de-DE"),
        title:
          "Akkumulerte Kostnader: akkumulerte kostnader (saksbehandlingskost + lokale driftskostnader) f.o.m. 01.01.2006 t.o.m. 31.05.2016",
      },
      {
        id: "rbns",
        label: "RBNS",
        align: "right",
        minWidth: 150,
        format: (value) => value.toLocaleString("de-DE"),
        title: "RBNS avsatt erstatningsreserve pr. 31.05.2016",
      },
      {
        id: "ibnr",
        label: "IBNR",
        align: "right",
        minWidth: 150,
        format: (value) => value.toLocaleString("de-DE"),
        title: "IBNR forventet erstatningsreserve pr. 31.05.2016",
      },
      {
        id: "result",
        label: "Forventet Resultat",
        align: "right",
        minWidth: 150,
        format: (value) => value.toLocaleString("de-DE"),
        title:
          "Forventet resultat = Akkumulert Betalt + Akkumulerte Kostnader + RBNS + IBNR pr. 31.05.2016",
      },
      {
        id: "summoned",
        label: "Tidligere Innkalt",
        align: "right",
        minWidth: 150,
        format: (value) => value.toLocaleString("de-DE"),
        title:
          "Tidligere innkalt akkumulert innkalt på årgangen pr. 31.05.2016",
      },
      {
        id: "coverage",
        label: "Over-/Under-dekning",
        align: "right",
        minWidth: 150,
        format: (value) => value.toLocaleString("de-DE"),
        title:
          "Over-/Underdekning = Forventet resultat - Tidligere innkalt pr. 31.05.2016",
      },
    ];

    return (
      <Container maxWidth="lg">
        <Backdrop
          open={this.state.loading}
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }}
        >
          <div style={{ textAlign: "center" }}>
            <CircularProgress />
            <div style={{ marginTop: 16 }}>
              Nedlasting pågår, vennligst vent...
            </div>
          </div>
        </Backdrop>

        <main style={{ width: "100%", paddingTop: 80 }}>
          <Paper style={{ width: "100%" }}>
            <div style={{ marginLeft: 20 }}>
              <FormControl component="fieldset">
                <RadioGroup
                  row
                  name="member"
                  value={this.state.member}
                  onChange={this.handleRadioButton}
                >
                  <h3>Statusrapport</h3>
                  <FormControlLabel
                    value="tff"
                    control={<Radio color="primary" />}
                    label="TFF"
                    labelPlacement="start"
                  />
                  <FormControlLabel
                    value="yff"
                    control={<Radio color="primary" />}
                    label="YFF"
                    labelPlacement="start"
                  />
                </RadioGroup>
              </FormControl>

              {this.state.fetching && (
                <div
                  style={{
                    marginLeft: 24,
                    display: "flex",
                    alignItems: "center",
                    fontSize: 14,
                  }}
                >
                  <CircularProgress size={20} style={{ marginRight: 8 }} />
                  Data laster, vennligst vent...
                </div>
              )}

            </div>
            <Paper style={{ margin: 10 }}>
              <div style={{ marginTop: 10, overflow: "auto" }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <Tooltip
                          key={column.id}
                          title={column.title || ""}
                          placement="bottom-start"
                        >
                          <TableCell
                            align={column.align}
                            style={{ minWidth: column.minWidth, cursor: "pointer" }}
                            onClick={() => this.sortBy(column.id)}
                          >
                            {column.label}
                          </TableCell>
                        </Tooltip>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.reports.length > 0 ? (
                      this.state.reports
                        .slice(
                          this.state.page * this.state.rowsPerPage,
                          this.state.page * this.state.rowsPerPage +
                          this.state.rowsPerPage
                        )
                        .map((report, index) => (
                          <TableRow key={index}>
                            {columns.map((column) => {
                              const value = report[column.id];
                              return (
                                <TableCell key={column.id} align={column.align}>
                                  {column.format && typeof value === "number"
                                    ? column.format(value)
                                    : value}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={columns.length} align="center">
                          Ingen treff
                        </TableCell>
                      </TableRow>
                    )}
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell key={column.id} align={column.align}>
                          {column.id === "incidentYear" ? "Total" : this.subtotal(column)}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableBody>
                </Table>
              </div>
              <TablePagination
                rowsPerPageOptions={[10, 50, 100]}
                component="div"
                count={this.state.reports.length || 0}
                rowsPerPage={this.state.rowsPerPage}
                page={this.state.page}
                onPageChange={this.handleChangePage}
                onRowsPerPageChange={this.handleChangeRowsPerPage}
              />
            </Paper>
            <div style={{ padding: 15, marginLeft: 10 }}>
              <Button
                variant="contained"
                color="primary"
                size="small"
                startIcon={<CloudDownloadIcon />}
                onClick={this.handledownload}
                disabled={this.state.loading || this.state.fetching}
              >
                {this.state.loading ? "Henter..." : "Vis i Excel"}
              </Button>
            </div>
          </Paper>
        </main>
        <ScrollToTopBtn />
      </Container>
    );
  }
}

export default StatusReport;
